"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWindowOpenObservable = createWindowOpenObservable;
const browser_core_1 = require("@datadog/browser-core");
function createWindowOpenObservable() {
    const observable = new browser_core_1.Observable();
    const { stop } = (0, browser_core_1.instrumentMethod)(window, 'open', () => observable.notify());
    return { observable, stop };
}
//# sourceMappingURL=windowOpenObservable.js.map